<template>
  <div>

        <v-row class="m-0" v-if="currentIndex > 0" style="height: 5vh;">
            <v-col cols="2" class="text-center pe-0 pb-0">
              <p class="wizard-page-number mb-0">{{ currentIndex }} <span class="wizard-total-page">sur {{ wizardItems.length - 1 }}</span></p>
            </v-col>

            <v-col class="text-end align-content-center pb-0">
              <v-icon @click="closeDialog" class="header-text">
                  fas fa-xmark
              </v-icon>
            </v-col>
        </v-row> 
        <div v-else style="height: 5vh;">

        </div>
 
        <div>
          <v-col class="d-flex align-center justify-center pb-6 pt-6">
            <img :src="currentWizardItem.picto" style="max-width: 100%; max-height: 60vh;"/>
          </v-col>

          <v-col class="pb-0 pt-5">
            <p class="wizard-title" v-html="currentWizardItem.title"></p>
          </v-col>

          <v-col class="pt-0">
            <p class="wizard-description"  v-html="currentWizardItem.description"></p>
          </v-col>
        </div>

        <v-row class="m-0">
          <v-col class="pe-1 align-content-center">
            <div v-if="currentIndex == 0" class="text-center">
                <p class="mb-0 wizard-skip" @click="closeDialog">Passer</p>
            </div>
            <loader-button v-else class=""
                           type='button'
                           label="Précédent"
                           :fullWidth="true"
                           :disabled="false"
                           :outlined="true"
                           @callback="previousStep">
            </loader-button>
          </v-col>
          <v-col class="ps-1">
            <loader-button class=""
                           type='button'
                           :label="nextLabel()"
                           :fullWidth="true"
                           :disabled="false"
                           @callback="nextStep">
            </loader-button>
          </v-col>
        </v-row>
  </div>
</template>

<script lang="ts">
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import Wizard from '@/generated/classes/Wizard';
import HtmlAttrib from '@/generated/classes/HtmlAttrib';
import WizardItem from '@/generated/classes/WizardItem';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
  name: 'SectionWizard',
  components: {
    LoaderButton,
    SectionHeader
  },
  props: {
    showHeader: {
      type: Boolean,
      required: false,
    },
    data: {
      type: Object as PropType<Wizard>,
      required: false,
    },
  },
  data() {
    return {
      wizardItems: [] as WizardItem[],
      currentIndex: 0,
    };
  },
  computed: {
    currentWizardItem(): WizardItem {
      return this.wizardItems[this.currentIndex]
    },
  },
  created(): void {
    if (this.data) {
      this.wizardItems = this.data.wizardItems;
      this.wizardItems.forEach((page) => {
        if (page.title == null) {
          HtmlAttrib.get(page.titleHtmlId).then((res) => {
            page.title = res.html;
          });
        }
        if (page.description == null) {
          HtmlAttrib.get(page.descriptionHtmlId).then((res) => {
            page.description = res.html;
          });
        }
      })
    }
  },
  methods: {
    nextLabel(): string {
      if (this.currentIndex == 0) {
        return 'Découvrir';
      } else if (this.currentIndex == this.wizardItems.length - 1) {
        return 'Terminer';
      } else {
        return 'Suivant';
      }
    },
    nextStep(): void {
      if (this.currentIndex == this.wizardItems.length - 1) {
        this.closeDialog();
      } else {
        this.currentIndex++;
      }
    },
    previousStep(): void {
      this.currentIndex--;
    },
    closeDialog(): void {
      this.$emit('closeDialog');
    },
  },
});
</script>